import { useLocation } from 'react-router-dom';

const useIsPageWithoutFooter = (): boolean => {
  const { pathname } = useLocation();

  return pathname === '/calendar' || pathname === '/owner/calendar';
};

export default useIsPageWithoutFooter;
